import { render, staticRenderFns } from "./PreviewUnavailable.vue?vue&type=template&id=2295a84c&scoped=true&"
import script from "./PreviewUnavailable.vue?vue&type=script&lang=js&"
export * from "./PreviewUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewUnavailable.vue?vue&type=style&index=0&id=2295a84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295a84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
